import styled from 'styled-components';
import Span from '../Typography/Span';
var StyledSpan = /*#__PURE__*/styled(Span).withConfig({
  displayName: "style__StyledSpan",
  componentId: "sc-1urvk9f-0"
})(["display:flex;flex-direction:row;align-items:center;color:", ";font-weight:", ";> span{margin-left:", ";}"], function (props) {
  return props.color;
}, function (props) {
  return props.fontWeight;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.spacing.sp4;
});
export default StyledSpan;